import { render, staticRenderFns } from "./PointsCount.vue?vue&type=template&id=a1c029f8&"
import script from "./PointsCount.vue?vue&type=script&lang=js&"
export * from "./PointsCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports